
import { buildFaqPageSchema } from '@/utils/faqSchema'

export default {
  name: 'FaqPageManager',
  // FaqItems register themselves via this, at any depth below the manager
  provide() {
    return {
      registerFaq: this.registerFaq,
    };
  },
  data() {
    return {
      // Every FAQ on the page, in render order
      faqItems: [],
    };
  },
  // This is the ONLY place on the page where the FAQPage schema is generated.
  // FaqItems register in created(), which runs during SSR, and vue-meta reads head()
  // after the whole page has rendered, so the schema is in the generated HTML.
  head() {
    const schema = buildFaqPageSchema(this.faqItems)
    if (!schema) return {}
    return {
      script: [{ hid: 'faq-page-schema', type: 'application/ld+json', json: schema }]
    }
  },
  methods: {
    registerFaq(item) {
      // Duplicate questions are dropped when the schema is built
      this.faqItems.push(item);
    },
  }
};
